import Marionette from 'backbone.marionette';
import _ from 'underscore';

var Item = Marionette.ItemView.extend({
  template(model){
    if(model == undefined){
      return '---------';
    }
    return model['code'] + ' ' +
      model['name'] + ' (' +
      model['unit_cost'] + ')';
  },
  tagName: 'option',
  attributes(){
    return {
      value: this.model.get('id')
    };
  }
});

var Dropdown = Marionette.CompositeView.extend({
  template: require('../templates/dropdown.html'),

  childViewContainer: '.costcentre',
  childView: Item,

  ui: {
    code: '.costcentre_code',
    dropdown: '.costcentre'
  },

  triggers: {
    'change @ui.code': 'updateSelect',
    'keyup @ui.code': 'updateSelect',
    'autocompletechange @ui.code': 'updateSelect',
    'change @ui.dropdown': 'updateCode'
  },

  onUpdateSelect: _.debounce(function (){
    var item = this.collection.findWhere({ code: this.ui.code.val() });
    if(item != undefined){
      this.ui.dropdown.val(item.get('id'));
      this.model.set(this.attribute, item.get('id'));
    }
  }, 300),

  onUpdateCode(){
    var item = this.collection.findWhere({ id: this.ui.dropdown.val()*1 });
    if(item != undefined){
      this.ui.code.val(item.get('code'));
      this.model.set(this.attribute, item.get('id'));
    }
  },

  onRender(){
    var self = this;
    var s = function (){
      self.onUpdateSelect();
      return true;
    };

    var item = this.collection.findWhere({ id: this.model.get(this.attribute) });
    if(item != undefined){
      this.ui.code.val(item.get('code'));
      this.ui.dropdown.val(item.get('id'));
    }

    this.ui.code.autocomplete({
      source: this.collection.pluck('code'),
      select: s,
      change: s,
      close: s
    });
  },

  tryRender(){
    try{
      this.render();
    } catch(e){} // eslint-disable-line no-empty
    // Throw away error, it's not essential
  },

  collectionEvents: {
    sync: 'render'
  },

  modelEvents: {
    sync: 'tryRender'
  }
});

module.exports = Dropdown;



// WEBPACK FOOTER //
// ./transactions/views/dropdown.js